import React from "react";
import SchemeBadge from "./SchemeBadge";
import {
    PAYMENT_PROVIDER_LABELS,
    PAYMENT_PROVIDER_COLORS,
    detectPaymentProvider,
} from "./paymentsConstants";

/**
 * Renders a colored badge identifying the payment provider
 * (Stripe or Orange Money) inferred from payment fields.
 * @param {Object} props - Badge props
 * @param {Object} props.payment - Payment dict from API
 * @returns {React.ReactElement}
 */
function PaymentProviderChip({ payment }) {
    const provider = detectPaymentProvider(payment);
    const scheme = PAYMENT_PROVIDER_COLORS[provider];
    const label = PAYMENT_PROVIDER_LABELS[provider];
    return <SchemeBadge scheme={scheme} label={label} />;
}

export default PaymentProviderChip;
